import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=41ebc422&scoped=true"
import script from "./AppDetail.vue?vue&type=script&lang=js"
export * from "./AppDetail.vue?vue&type=script&lang=js"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=41ebc422&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ebc422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/dev-official-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ebc422')) {
      api.createRecord('41ebc422', component.options)
    } else {
      api.reload('41ebc422', component.options)
    }
    module.hot.accept("./AppDetail.vue?vue&type=template&id=41ebc422&scoped=true", function () {
      api.rerender('41ebc422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AppCenter/AppDetail.vue"
export default component.exports